import { RouteConfig } from 'vue-router'
import Layout from '@/layout/index.vue'

const taskRoutes: RouteConfig = {
  path: '/task',
  component: Layout,
  meta: {
    title: 'taskCenter',
    icon: 'hamburger',
    alwaysShow: true
  },
  children: [
    {
      path: 'applicationTask',
      name: 'Admin Task',
      component: () => import('@/views/task/applicationTask/index.vue'),
      meta: {
        title: 'applicationTask',
        icon: 'skill',
        activeMenu: '/task/applicationTask'
      }
    },
    {
      path: 'withdrawReview',
      name: 'Withdraw Review',
      component: () => import('@/views/task/withdrawReview/index.vue'),
      meta: {
        title: 'withdrawReview',
        icon: 'zhichu',
        activeMenu: '/task/withdrawReview'
      }
    },
    {
      path: 'depositReview',
      name: 'Deposit Review',
      component: () => import('@/views/task/depositReview/index.vue'),
      meta: {
        title: 'depositReview',
        icon: 'shouru',
        activeMenu: '/task/depositReview'
      }
    },
    {
      path: 'exceptionTask',
      name: 'Abnormal Order',
      component: () => import('@/views/task/exceptionTask/index.vue'),
      meta: {
        title: 'exceptionTask',
        icon: 'bug',
        activeMenu: '/task/exceptionTask'
      }
    },
    {
      path: 'antOrderReview',
      name: 'Ant Order Review',
      component: () => import('@/views/task/antOrderReview/index.vue'),
      meta: {
        title: 'antOrderReview',
        icon: 'zhichu',
        activeMenu: '/task/antOrderReview'
      }
    },
    {
      path: 'antRegister',
      name: 'Ant Register Review',
      component: () => import('@/views/task/antRegister/index.vue'),
      meta: {
        title: 'antRegister',
        icon: 'zhichu',
        activeMenu: '/task/antRegister'
      }
    },
    {
      path: 'antReview',
      name: 'Ant USDT TRX Review',
      component: () => import('@/views/task/antReview/index.vue'),
      meta: {
        title: 'antReview',
        icon: 'zhichu',
        activeMenu: '/task/antReview'
      }
    }
  ]
}

export default taskRoutes
